// extracted by mini-css-extract-plugin
export var breakLine = "BreakLine_breakLine__7TMxn";